// src/slices/mySlice.js
import { createSlice } from '@reduxjs/toolkit';

export const mySlice = createSlice({
    name: 'myState',
    initialState: {
        value: 'Hello from Redux Toolkit',
    },
    reducers: {
        setValue: (state, action) => {
            state.value = action.payload;
        },
    },
});

export const { setValue } = mySlice.actions;

export default mySlice.reducer;
